const i18n = {
	phoneFieldMessage: {
		1 : ["Поле заполнено некорректно. Поле должно содержать ", " цифр."],
		0 : ["Поле запоўнена некарэктна. Поле павінна ўтрымліваць ", " лічбаў."]
	},
	confirmPhone: {
		1 : "Подтверждение номера",
		0 : "Пацверджанне нумара"
	},
	confirmCode: {
		1 : "Код подтверждения",
		0 : "Код пацверджання"
	},
	requiredField: {
		1 : "Поле обязательно для заполнения.",
		0 : "Поле абавязкова для запаўнення."
	},
	confirmPhoneNumber: {
		1 : "Подтвердить",
		0 : "Пацвердзіць"
	},
	validatePhoneNumberMessage: {
		1: 'Номер телефона введен некорректно',
		0: 'Нумар тэлефона ўведзены некарэктна'
	},
	confirmTextPhone: {
		1 : "На номер телефона {0} был отправлен код подтверждения. ",
		0 : "На нумар тэлефона {0} быў адпраўлены код пацверджання. "
	},
	confirmTextInputBold: {
		1 : "Введите код в поле ниже. ",
		0 : "Калі ласка, увядзіце код у поле ніжэй. "
	},
	confirmInputPlaceHolder: {
		1 : "Введите код",
		0 : "Увядзіце код"
	},
	confirmTextRepeat: {
		1 : (isNow) => (!isNow ? "Повторно запросить код можно будет через {0} сек. " : "Повторно запросить код можно сейчас. "),
		0 : (isNow) => (!isNow ? "Паўторна запытаць код можна будзе праз {0} сек. " : "Повторно запросить код можно зараз. ")
	},
	repeatCode: {
		1: [
			"Отправить повторно ",
			"через: ",
			" с"
		],
		0: [
			"Адправіць паўторна ",
			"праз: ",
			" с"
		]
	},
	codeLoading: {
		1 : "Идет отправка кода подтверждения на указанный номер",
		0 : "Ідзе адпраўка кода пацверджання на указаны нумар"
	}
}

export default i18n
